/**
 * Converte uma string base64 em um objeto File.
 *
 * @param base64 - A string base64 a ser convertida.
 * @param fileName - O nome do arquivo a ser criado.
 * @returns Uma promessa que resolve com o objeto File.
 */
export function base64ToFile(base64: string, fileName: string): Promise<File> {
    return fetch(base64)
      .then((res) => res.blob())
      .then((blob) => new File([blob], fileName, { type: 'image/png' }));
  }